import React from "react";

import Route from "./Auth";
import { Redirect, Switch } from "react-router-dom";

import Home from "../Pages/Home";
import Expedition from "../Pages/Expedition";
import ExpeditionV2 from "../Pages/ExpedtionV2";
import AbandonedCart from "../Pages/AbandonedCart";
import QuantatyOrders from "../Pages/QuantatyOrders";

import Menu from "../Pages/Menu";
import Users from "../Pages/Users";
import PageFormUser from "../Pages/Users/form";
import Login from "../Pages/Login";
import EggShellOrder from "../Pages/EggShellOrders";
import EggShellSeparate from "../Pages/EggShellSeparete";
import NewEggSeparateShell from "../Pages/NewEggSeparateShell";
import DashboardShells from "../Pages/Dashboards/Shells";
import ManagerSku from "../Pages/ManagerSkus";
import Ranking from "../Pages/Embalei/Ranking";
import Search from "../Pages/Embalei/Search";
import MetaEmbalei from "../Pages/Embalei/MetaEmbalei";
import Attendance from "../Pages/Attendance";
import Sac from "../Pages/Sac";
import SacV2 from "../Pages/SacV2";
import Ebook from "../Pages/Ebook";
import ListEbook from "../Pages/ListEbook";
import FullGoals from "../Pages/Dashboards/FullGoals";
import ConfigFullGoals from "../Pages/Settings/FullGoals";
import RetiraJa from "../Pages/RetiraJa";
import Telesales from "../Pages/Telesales";
import OffersNewspaper from "../Pages/OffersNewspaper";
import UsersEmbalei from "../Pages/Embalei/Users";
import ListSeals from "../Pages/ListSeals";
import AddSeal from "../Pages/AddSeal";
import ExpeditionV3 from "../Pages/ExpeditionV3";
import Embarque from "../Pages/Embarque";
import GoalsExpedition from "../Pages/ExpeditionV3/Meta";
import CarriersExpedition from "../Pages/Embarque/Transportadora";
import MarginSimulator from "../Pages/MarginSimulator";
import CicloTempo from "../Pages/Ciclo";
import SantoLogMaps from "../Pages/SantoLog/Maps";
import SantoLogAreas from "../Pages/SantoLog/Maps/Areas";
import SantoLogDrivers from "../Pages/SantoLog/Drivers";
import SantoLogCarriers from "../Pages/SantoLog/Carriers";
import SantoLogOrders from "../Pages/SantoLog/Orders";
import SantoLogBoxes from "../Pages/SantoLog/Boxes";
import SantoLogEmbark from "../Pages/SantoLog/Embark";
import SantoLogHome from "../Pages/SantoLog/Home";
import SantoLogSeparacao from "../Pages/SantoLog/Separacao";
import SantoLogDevolucao from "../Pages/SantoLog/Devolucao";
import SantoLogTransferencia from "../Pages/SantoLog/Transferencia";
import SantoLogRomaneio from "../Pages/SantoLog/Romaneio";
import SantoLogAuditoria from "../Pages/SantoLog/Auditoria";
import SantoLogFechamentoFrete from "../Pages/SantoLog/FechamentoFrete";
import IntegracaoEmbarque from "../Pages/Integracao/Embarque";
import OndasDashboardLive from "../Pages/Ondas/DashboardLive";
import RankingCashier from "../Pages/RankingCashier";
import Productivity from "../Pages/Productivity";
import Shipping from "../Pages/Shipping";
import TrackingPerformance from "../Pages/Tracking";
import GenerateLabels from "../Pages/GenerateLabels";
import MarketplacesDashboard from "../Pages/Marketplaces/Dashboard";

const Routes = () => {
  return (
    <Switch>
      {/* Rota inicial pós-login (sem idPage) */}
      <Route exact path={"/home"} component={Home} isPrivate />

      {/* Rotas ordenadas por idPage (crescente) */}
      <Route
        exact
        path={"/dashboard/expedicao"}
        idPage={1}
        component={Expedition}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/sac"}
        idPage={2}
        component={Sac}
        isPrivate
      />
      <Route
        exact
        path={"/configuracao/menu"}
        idPage={3}
        component={Menu}
        isPrivate
      />
      <Route
        exact
        path={"/configuracao/usuarios"}
        idPage={4}
        component={Users}
        isPrivate
      />
      <Route
        exact
        path={"/configuracao/usuarios/novo"}
        idPage={5}
        component={PageFormUser}
        isPrivate
      />
      <Route
        exact
        path={"/configuracao/usuarios/editar/:id"}
        idPage={6}
        component={PageFormUser}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/carrinho-abandonado"}
        idPage={8}
        component={AbandonedCart}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/quantidade-de-pedidos"}
        idPage={9}
        component={QuantatyOrders}
        isPrivate
      />
      <Route
        exact
        path={"/cascas/separar-cascas"}
        idPage={10}
        component={NewEggSeparateShell}
        isPrivate
      />
      <Route
        exact
        path={"/cascas/adicionar-cascas"}
        idPage={11}
        component={EggShellOrder}
        isPrivate
      />
      <Route
        exact
        path={"/gerenciamento-sku"}
        idPage={12}
        component={ManagerSku}
        isPrivate
      />
      <Route
        exact
        path={"/cascas/separar-cascas-v2"}
        idPage={13}
        component={NewEggSeparateShell}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/cascas"}
        idPage={14}
        component={DashboardShells}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/expedicao-v2"}
        idPage={15}
        component={ExpeditionV2}
        isPrivate
      />
      <Route
        exact
        path={"/atendimento/novo"}
        idPage={16}
        component={Attendance}
        isPrivate
      />
      <Route
        exact
        path={"/embalei/pesquisa"}
        idPage={17}
        component={Search}
        isPrivate
      />
      <Route
        exact
        path={"/embalei/ranking"}
        idPage={18}
        component={Ranking}
        isPrivate
      />
      <Route
        exact
        path={"/embalei/meta"}
        idPage={19}
        component={MetaEmbalei}
        isPrivate
      />
      <Route
        exact
        path={"/ebook/novo"}
        idPage={20}
        component={Ebook}
        isPrivate
      />
      <Route
        exact
        path={"/ebook/listar"}
        idPage={21}
        component={ListEbook}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/metas-gerais"}
        idPage={22}
        component={FullGoals}
        isPrivate
      />
      <Route
        exact
        path={"/configuracao/metas-gerais"}
        idPage={23}
        component={ConfigFullGoals}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/sac-v2"}
        idPage={24}
        component={SacV2}
        isPrivate
      />
      <Route
        exact
        path={"/retiraja"}
        idPage={26}
        component={RetiraJa}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/televendas"}
        idPage={27}
        component={Telesales}
        isPrivate
      />
      <Route
        exact
        path={"/jornal-ofertas"}
        idPage={28}
        component={OffersNewspaper}
        isPrivate
      />
      <Route
        exact
        path={"/embalei/usuario"}
        idPage={29}
        component={UsersEmbalei}
        isPrivate
      />
      <Route
        exact
        path={"/selos/adicionar"}
        idPage={30}
        component={AddSeal}
        isPrivate
      />
      <Route
        exact
        path={"/selos/ativar-desativar"}
        idPage={31}
        component={ListSeals}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/metas/expedicao"}
        idPage={32}
        component={GoalsExpedition}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/embarque"}
        idPage={33}
        component={Embarque}
      />
      <Route
        exact
        path={"/dash/exp"}
        idPage={34}
        component={ExpeditionV3}
      />
      <Route
        exact
        path={"/consulta-margem"}
        title="Consulta Margem"
        idPage={35}
        component={MarginSimulator}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/transportadoras"}
        idPage={36}
        component={CarriersExpedition}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/mapa"}
        idPage={37}
        component={SantoLogMaps}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/home"}
        idPage={38}
        component={SantoLogHome}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/ciclo"}
        idPage={39}
        component={CicloTempo}
      />
      <Route
        exact
        path={"/santolog/areas"}
        idPage={40}
        component={SantoLogAreas}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/ranking-caixas"}
        idPage={41}
        component={RankingCashier}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/produtividade"}
        idPage={42}
        component={Productivity}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/motoristas"}
        idPage={43}
        component={SantoLogDrivers}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/transportadoras"}
        idPage={44}
        component={SantoLogCarriers}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/tracking"}
        idPage={45}
        component={TrackingPerformance}
      />
      <Route
        exact
        path={"/dashboard/conciliacao-frete"}
        idPage={46}
        component={Shipping}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/pedidos"}
        idPage={47}
        component={SantoLogOrders}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/boxes"}
        idPage={48}
        component={SantoLogBoxes}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/embarcar"}
        idPage={49}
        component={SantoLogEmbark}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/separacao"}
        idPage={50}
        component={SantoLogSeparacao}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/devolucao"}
        idPage={51}
        component={SantoLogDevolucao}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/transferencia"}
        idPage={52}
        component={SantoLogTransferencia}
        isPrivate
      />
      <Route
        exact
        path={"/dashboard/gerar-etiquetas"}
        idPage={53}
        component={GenerateLabels}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/romaneio"}
        idPage={54}
        component={SantoLogRomaneio}
        isPrivate
      />
      <Route
        exact
        path={"/integracao/embarque"}
        idPage={55}
        component={IntegracaoEmbarque}
        isPrivate
      />
      <Route
        exact
        path={"/santolog/auditoria"}
        idPage={56}
        component={SantoLogAuditoria}
        isPrivate
      />
      {/* Conferência da fatura da transportadora — planilhas ficam no navegador */}
      <Route
        exact
        path={"/santolog/fechamento-frete"}
        idPage={62}
        component={SantoLogFechamentoFrete}
        isPrivate
      />
      {/* Ondas AO VIVO (WMS Sonar + IDWorks) — andar/data via query string */}
      <Route
        exact
        path={"/dashboard/ondas"}
        idPage={60}
        component={OndasDashboardLive}
      />
      <Route
        exact
        path={"/marketplaces/dashboard"}
        idPage={61}
        component={MarketplacesDashboard}
        isPrivate
      />
      {/* Login e fallback */}
      <Route exact path={"/"} component={Login} />
      <Redirect to="/" />
    </Switch>
  );
};

export default Routes;
